module.exports = __webpack_public_path__ + "static/media/nptel.55da6f93.png";